export const PHONE_TYPES = {
  WORK: 'work',
  OTHER: 'other',
  MOBILE: 'mobile',
  HOME: 'home',
};

export const PHONE_TYPES_ENUM = ['WORK', 'HOME', 'MOBILE', 'OTHER'];
